module.exports = __webpack_public_path__ + "static/media/dog-4.00802e40.jpg";